import * as React from 'react'
import { tw } from 'utils/classnames'
import { useTranslations } from 'next-intl'
import { useUserId } from '@repo/cf-user/hooks/use-user-data'

import { useContentMyReviewQuery } from '@web/gen/content'
import { PenIcon } from '@web/components/icons/pen'
import { useProductId } from '@web/app/[locale]/(web)/prod/[slug]/product-id-context'

export interface ReviewButtonProps extends React.PropsWithChildren {
  className?: string
  setIsModalOpen: (value: boolean) => void
  readOnly?: boolean
}

export function ReviewButton({ setIsModalOpen, className, readOnly, children }: ReviewButtonProps) {
  const t = useTranslations('prod.product_description_page.reviews')
  const currentUserId = useUserId()
  const isLoggedIn = Boolean(currentUserId)
  const productId = useProductId()
  const { data: userReview, isPending: userReviewIsLoading } = useContentMyReviewQuery(
    {
      productId: productId ?? '',
    },
    {
      enabled: Boolean(currentUserId),
    },
  )
  const currentUserReview = userReview?.contentMyReview
  const isEditReview = Boolean(currentUserReview)
  // oxlint-disable-next-line no-nested-ternary
  const label = readOnly ? 'view' : isEditReview ? 'edit' : 'write'

  return (
    <>
      <button
        className={tw(
          'bg-cf-white rounded-2 hover:shadow-cf-elevation-light-1 grow-0 border border-[#DFDDE5]',
          'flex items-center justify-center gap-2 whitespace-nowrap p-2 px-4',
          className,
        )}
        onClick={() => {
          setIsModalOpen(true)
        }}
        disabled={isLoggedIn ? userReviewIsLoading : false}
      >
        <PenIcon />
        <span>{children ?? t(label)}</span>
      </button>
    </>
  )
}
